/** @prettier */

import Grid from '@mui/material/Grid';
import {ReactElement} from 'react';

//Style import
import '../css/common/common.css';

/**
 * Cardコンテンツ内に表示するメッセージ
 * @param props props
 * @returns JSX
 * - valueDescription 値の説明
 * - value 値
 * - class コンテンツに適用するクラス
 * - valueID 値のID
 */
const CardContents = (props: {
  valueDescription: string;
  value: string | ReactElement;
  class?: string;
  valueID?: string;
}) => {
  return (
    <>
      <Grid container spacing={0} className={props.class}>
        <Grid item xs={5}>
          {props.valueDescription}
        </Grid>
        <Grid item xs={7} id={props.valueID}>
          {props.value}
        </Grid>
      </Grid>
    </>
  );
};
export default CardContents;
